import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import toronto from "../images/torontoclip.png";
import orlando from "../images/orlando.png";
import denver from "../images/denver.png";
import atlanta from "../images/atlanta.png";
import mississauga from "../images/mississauga.png";
import ottawa from "../images/ottawaclip.png";
import calgary from "../images/calgary.png";
import vancouver from "../images/vancouver.png";


const destinations = [
  { name: "Toronto", image: toronto },
  { name: "Orlando", image: orlando },
  { name: "Denver", image: denver },
  { name: "Atlanta", image: atlanta },
  // { name: "Mississauga", image: mississauga },
  { name: "Ottawa", image: ottawa },
  { name: "Calgary", image: calgary },
  { name: "Vancouver", image: vancouver },
];

function FamousDestination() {
  return (
    <div className="bg-[#006039] px-0 py-12 text-[#EDEBEC] border border-b border-[#edebec]">
      <style>
        {`
          /* Style for navigation arrows on larger screens */
          .destination-swiper .swiper-button-prev,
          .destination-swiper .swiper-button-next {
            top: 50% !important;
            transform: translateY(-50%) !important;
          }

          .destination-swiper .swiper-button-prev::after,
          .destination-swiper .swiper-button-next::after {
            font-size: 20px !important;
            color: #EDEBEC !important; 
          }

          /* --- FIX: Hide arrows on smaller screens --- */
          @media (max-width: 768px) {
            .destination-swiper .swiper-button-prev,
            .destination-swiper .swiper-button-next {
              display: none !important; /* This hides the arrows */
            }
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto p-2 sm:p-6 lg:p-8 ">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-semibold">
            Famous Destinations
          </h1>
          <p className="mt-2 font-medium text-sm md:text-base">
            Explore trending locations around the globe
          </p>
        </div>

        <div className="max-w-[95vw] mx-auto">
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={5}
            navigation // This can remain true; CSS will handle visibility
            centeredSlides={false}
            className="w-full destination-swiper"
            breakpoints={{
              320: { slidesPerView: 2.5 },
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
            }}
          >
            {destinations.map((city, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col items-center">
                  <div className="w-28 h-28 md:w-32 md:h-32 rounded-full overflow-hidden shadow-md border border-[#EDEBEC]">
                    <img
                      src={city.image}
                      alt={city.name.trim()}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="mt-2 text-center text-[#EDEBEC] font-medium">
                    {city.name.trim()}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default FamousDestination;
